import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { Credentials } from "auth";
import { State } from "redux/state";

import { RemoveUserOpts, UserId } from "@xapp/stentor-api-client/dist/StentorClient";

export type RemoveUserFromOrganization = "REMOVE_USER_FROM_ORGANIZATION";
export const REMOVE_USER_FROM_ORGANIZATION: RemoveUserFromOrganization = "REMOVE_USER_FROM_ORGANIZATION";
export type RemoveUserFromOrganizationEnd = "REMOVE_USER_FROM_ORGANIZATION_END";
export const REMOVE_USER_FROM_ORGANIZATION_END: RemoveUserFromOrganizationEnd = "REMOVE_USER_FROM_ORGANIZATION_END";

export interface RemoveUserFromOrganizationAction extends Action {
    payload: {
        credentials: Credentials;
        opts?: RemoveUserOpts;
        organizationId: string;
        userId: UserId;
    };
    type: RemoveUserFromOrganization;
}

export interface RemoveUserFromOrganizationEndAction extends Action {
    payload: {
        error?: Error;
        opts?: RemoveUserOpts;
        organizationId: string;
        userId: UserId;
    };
    type: RemoveUserFromOrganizationEnd;
}

export function removeUserFromOrganization(
    organizationId: string,
    userId: UserId,
    opts?: RemoveUserOpts
): ThunkAction<any, State, any, RemoveUserFromOrganizationAction> {
    return (dispatch: Dispatch<RemoveUserFromOrganizationAction>, getState) => {
        const credentials = getState().auth.credentials;

        dispatch(removeUserFromOrganizationWithCredentials(credentials, organizationId, userId, opts));
    };
}

function removeUserFromOrganizationWithCredentials(
    credentials: Credentials,
    organizationId: string,
    userId: UserId,
    opts: RemoveUserOpts
): RemoveUserFromOrganizationAction {
    return {
        payload: {
            credentials,
            opts,
            organizationId,
            userId
        },
        type: REMOVE_USER_FROM_ORGANIZATION
    };
}

export function removeUserFromOrganizationEnd(
    error: Error,
    organizationId: string,
    userId: UserId,
    opts?: RemoveUserOpts
): RemoveUserFromOrganizationEndAction {
    return {
        payload: {
            error,
            organizationId,
            userId
        },
        type: REMOVE_USER_FROM_ORGANIZATION_END
    };
}
